module.exports = __webpack_public_path__ + "static/media/rep-logo.05d193d2.svg";